var React = require('react');

function CompareArrowsAlt (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"15.6 30.1 5.7 40 8.5 42.8 18.4 32.9 22.7 37.1 22.7 25.8 11.3 25.8 15.6 30.1","key":0}),React.createElement("polygon",{"points":"37.7 22.2 33.4 17.9 43.3 8 40.5 5.2 30.6 15.1 26.3 10.9 26.3 22.2 37.7 22.2","key":1})]);
}

CompareArrowsAlt.displayName = "CompareArrowsAlt";

CompareArrowsAlt.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CompareArrowsAlt;

CompareArrowsAlt.default = CompareArrowsAlt;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/compare_arrows_alt.svg